import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import * as reportService from "../../../services/adsSubscribers.service";
import "react-datepicker/dist/react-datepicker.css";
import Chart from "react-apexcharts";
import { formatDateToString } from "./../../../utils/common";
import LoadingIcon from "../../../components/LoadingIcon";
import { clearState } from "../../../redux/actions/authActions";

export default function AdsDayChart({accessToken}) {
  const now = new Date();
  const [date, setDate] = useState(now);
  const [data, setData] = useState([]);
  const [clicksCount, setClicksCount] = useState([]);
  const [noData, setNoDate] = useState(true);
  const dispatch = useDispatch()
  const dayHours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ];

  const handleDateChange = (date) => {
    setDate(date);
    createReport();
  };

  const series = [
    {
      name: "Subscription from Ads Clicks",
      data: data,
    },
    {
      name: "Clicks Count",
      data: clicksCount,
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      events: {
        mounted: function () {
          createReport(formatDateToString(date));
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "Users subscriptions / Ads clicks , by day",
      align: "left",
      style: {
        fontFamily: "Segoe UI",
        fontWeight: 600,
      },
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      type: "time",
      categories: dayHours,
    },
    yaxis: [
      {
        categories: data,
        seriesName: "Subscription from Ads Clicks",
        axisTicks: {
          show: true,
          color: "#008FFB",
        },
        axisBorder: {
          show: true,
          color: "#008FFB",
        },
        labels: {
          style: {
            colors: "#008FFB",
          },
        },
        title: {
          text: "Subscribtions",
          style: {
            color: "#008FFB",
          },
        },
      },
      {
        categories: clicksCount,
        seriesName: "Clicks Count",
        opposite: true,
        axisTicks: {
          show: true,
          color: "#00E396",
        },
        axisBorder: {
          show: true,
          color: "#00E396",
        },
        labels: {
          style: {
            colors: "#00E396",
          },
        },
        title: {
          text: "Clicks",
          style: {
            color: "#00E396",
          },
        },
      },
    ],
  };

  const structureData = (data) => {
    let newChartData = new Array(24).fill(0);
    let newClickCount = new Array(24).fill(0);
    data.forEach((dataRow, index) => {
      newChartData[index] = dataRow.subscriptionCount;
      newClickCount[index] = dataRow.clickCount;
    });
    return { newChartData, newClickCount };
  };

  const createReport = () => {
    if (date) {
      reportService
        .AdsSubscriptionsByDate(formatDateToString(date), accessToken)
        .then((response) => {
          if (response.data.status === true) {
            let { newChartData, newClickCount } = structureData(
              response.data.data
            );
            setData(newChartData);
            setClicksCount(newClickCount);
            setNoDate(false);
          } 
          else {
            console.log(response);
            setNoDate(true);
          }
        })
        .catch((error) => {
              if(error.response.status===401) {
                console.log(error);
                dispatch(clearState())
            }
        })
    }
  };

  useEffect(() => {
    setDate(new Date());
  }, []);

  useEffect(() => {
    createReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <>
      <div className="flex">
        <DatePicker
          selected={date}
          onChange={(date) => handleDateChange(date)}
          wrapperClassName="date-picker-wrapper"
        />
      </div>
      <div className="mt-4">
        {noData ? (
          <div className="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
              />
            </svg>
            <span className="mt-2 block text-sm font-medium text-gray-900">
              No data for the specified date range.
            </span>
          </div>
        ) : (
          (data || clicksCount) &&
          (data.length > 0 || clicksCount.length > 0) && (
            <Chart options={options} series={series} type="line" height={350} />
          )
        )}
      </div>
    </>
  );
}
